<script lang="jsx">
import mixin from '@/plans/mx/shopping-cart';
import commonMixin from '@/plans/ZOOM_REVENUE_ACCELERATOR/mixin';
import { pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { getPlanUnitWithQuantity, planUnitMap } from '@/common/product-unit';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';

export default {
  mixins: [mixin, commonMixin],
  name: 'ZoomRevenueAcceleratorCart',
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  computed: {
    showRemove() {
      const fromPlanType = getPlanTypeByCategory(pageConfig.plan);
      return fromPlanType !== this.planType;
    },
  },
  methods: {
    mx_license(num) {
      return (
        <div class="opc-cart-item__text">
          {num} {getPlanUnitWithQuantity(planUnitMap.license)}
        </div>
      );
    },
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            return (
              <div>
                {this.mx_title(this.title, <AltProratedPlanPrice type={plan.type}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice> )}
                {this.mx_discount(plan.plan_code)}
                {this.mx_cycle(plan.billing_cycle)}
                <AltProratedPlanUser type={plan.type}>
                {this.mx_license(plan.cartInfo.selected_number)}
                </AltProratedPlanUser>
                <AltProratedPlanPeriod type={plan.type} />
                {this.mx_edit(plan)}
                { this.showRemove && this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>
